import React from "react";
import { Table } from "antd";
import useIsMobile from "../../../hooks/useIsMobile";
import "./FacilityDietTable.css";

const FacilityDietTable = ({ dietData, loading }) => {
  const isMobile = useIsMobile();
  // Default columns to an empty array
  let columns = [];

  const getFixedColumn = (key) => {
    if (isMobile) {
      return key === "room_no" ? "left" : false;
    }

    if (key === "patient_name" || key === "diet_type") {
      return "left";
    }

    if (key === "comments") {
      return "right";
    }

    return false;
  };

  const getColumnWidth = (key) => {
    if (isMobile && key === "room_no") {
      return 88;
    }

    if (isMobile && key === "comments") {
      return 220;
    }

    return 150;
  };

  if (dietData && dietData.length > 0) {
    // Define the desired initial column order
    const initialColumns = ["room_no", "patient_name", "diet_type"];

    // Extract all keys from the first item in dietData and filter out unwanted keys
    const allKeys = Object.keys(dietData[0] || {}).filter(
      (key) => key !== "admission_id"
    );

    // Determine the remaining keys not in the initialColumns
    const remainingKeys = allKeys.filter(
      (key) => !initialColumns.includes(key)
    );

    // Function to format keys as 12-hour time if they are numbers
    const formatKeyAsTime = (key) => {
      if (!isNaN(key)) {
        const hour = Number(key);
        const period = hour === 24 ? "AM" : hour >= 12 ? "PM" : "AM";
        const formattedHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
        return `${formattedHour}:00 ${period}`;
      }
      return key;
    };

    // Combine initialColumns and remainingKeys to define the final column order
    const columnOrder = [...initialColumns, ...remainingKeys];

    // Filter out columns with empty strings for all rows
    const validColumns = columnOrder.filter((key) =>
      dietData.some((item) => item[key] && item[key].trim() !== "")
    );

    // Generate columns dynamically based on the valid columns
    columns = validColumns.map((key) => ({
      title: formatKeyAsTime(key) // Format the header as time if it's a number
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/^\w/, (c) => c.toUpperCase()), // Capitalize the first letter
      dataIndex: key,
      key,
      render: (value) => value || "-", // Display "-" for empty or null values
      width: getColumnWidth(key),
      fixed: getFixedColumn(key),
      ...(isMobile && key === "comments"
        ? {
            ellipsis: false,
            onCell: () => ({
              style: {
                whiteSpace: "normal",
                wordBreak: "break-word",
              },
            }),
          }
        : {}),
    }));
  }

  return (
    <div
      className={`facility-diet-table-wrap${
        isMobile ? " facility-diet-table-wrap--mobile" : ""
      }`}
    >
      <Table
        className="facility-diet-table"
        columns={columns}
        dataSource={dietData}
        loading={loading}
        pagination={false}
        scroll={{ x: isMobile ? "max-content" : 2000 }}
        rowKey={(record, index) => record?.admission_id ?? index}
      />
    </div>
  );
};

export default FacilityDietTable;
